// extracted by mini-css-extract-plugin
export default {"copy-text-input":"styles__copy-text-input____Z_W2"};